import Enumerable from "linq";
import { Cell, Header, Row, Table } from "../system/table";
import { HisInformationItemSet } from ".";
import { LoggerFactory } from "../../utilities/logger";

export class HisInformationTableConverter {
  public static convert(baseTable: Table, hisItemSets: HisInformationItemSet[]): Table {
    try {
      if (!baseTable || !hisItemSets || hisItemSets.length === 0) {
        // TODO: 0件の時の対応
        return new Table([], []);
      }
      const headers = baseTable.headers.filter(h => hisItemSets[0].items.some(i => i.name === h.value)).map(h => h.clone());
      const rows = hisItemSets.map(set => this.toTableRow(headers, set));
      return new Table(headers, rows);
    } catch (e) {
      // エラーは発生させないようにしているが、念のためガードしておく
      LoggerFactory.getLogger().warn(e);
    }
  }

  private static toTableRow(headers: Header[], set: HisInformationItemSet): Row {
    const cells = Enumerable.from(headers)
      .select(h => Enumerable.from(set.items).firstOrDefault(i => i.name === h.value))
      .select(i => new Cell(!!i ? i.value : ""))
      .toArray();
    return new Row(cells);
  }
}
